import {useState} from 'react';

export function Pizza () {

  const [nbPart, setNbPart] = useState(1)
  const [etape, setEtape] = useState(0)

  /*const handleClick = (e) => {
  	let nb = e.target.name*1 
  	setNbPart(nb)
	setEtape(1)
  }*/

  const consigne = {
  	31:<div><h1>Couper en 3 parts</h1><br/>Pour couper cette pizza en 3 parts, commençons par repérer un diamètre [AB] de la pizza.</div>,
  	32:<div>On évalue le milieu O de [AB] et on coupe un rayon [OA].</div>,
  	33:<div>On évalue le milieu D de [OB] et on place la lame du couteau sur la pizza en D, perpendiculairement à [OB].</div>,
  	34:<div>Cela détermine un point C d'une part et un point E d'autre part.</div>,
  	35:<div>Il ne reste plus qu'a couper la pizza suivant [OC] et [OE].</div>,
  	51:<div><h1>Couper en 5 parts</h1><br/>Pour couper cette pizza en 5 parts, nous allons utiliser une feuille de papier au format A4.<br/>
  		Avec cette feuille, nous allons voir une méthode permettant de construire un pentagone quasi-régulier.</div>,
  	52:<div><h1>Etape 1</h1> Commençons par ramener A sur B.</div>,
  	53:<div><h1>Etape 2</h1> Ramener C sur D pour faire un pli.</div>,
  	54:<div><h1>Etape 3</h1> Ramener les segments [CE] et [FD] parallèles au pli précédent mais distants entre eux d'environ <b>1 cm</b>.</div>,
  	55:<div><h1>Etape 4</h1> Voici un superbe pentagone quasi-régulier que l'on peut placer au centre de la pizza.</div>,
  	56:<div><h1>Etape 5</h1> Maintenant, utilisons notre couteau tranchant pour couper la pizza en partant de chaque sommet du pentagone.</div>,
  	57:<div><h1>Etape 6</h1> il ne reste plus qu'à retirer la feuille pliée et finir la découpe.</div>,
   	61:<div><h1>Couper en 6 parts</h1><br/>Pour couper cette pizza en 6 parts, commençons par la couper suivant un diamètre [AB] et évaluons le milieu O de ce diamètre.</div>,
   	61:<div>On évalue le milieu D de [OA] et on place la lame du couteau en D, perpendiculairement à [OA]. </div>,
   	62:<div>Ceci permet de déterminer deux points C et E sur le bord de la pizza. </div>,
   	63:<div>On coupe enfin deux diamètres de pizza suivant (OC) et (OE). </div>,
 }

  return (
    <div>
    	Couper cette pizza en... 
    	{
    		[3, 5, 6, 7].map((e, k)=>
    			<input key={k} className="btn" type="button" name={e} value={e+ ' parts égales'} onClick={()=>{
						    				setNbPart(e)
						    				setEtape(1)
				    					}} />)
    	}
    	<div className="flex">
    		<div style={{width:'fit-content', border: '1px solid #000'}}>
    		<img src="https://maths-au-quotidien.fr/images/pizza.jpg" alt="pizza" /><br/>
    		</div>
    		<div style={{width:'45%', border: '1px solid #000'}}>
	    		{consigne[nbPart*10 + etape]}<br/>
	    		{etape > 0 ? <img src="https://maths-au-quotidien.fr/images/fleched.png" alt="suivant" onClick={()=>{
	    				console.log(consigne, 62)
	    				const n = ([62, 63].includes(nbPart*10 + etape) ? 0 : etape + 1)
		    			setEtape(n)
		    		}} /> : ''}
    		</div>
    	</div>
    	

    	<br/><br/><br/>
    	etape : {etape}<br/>
    	nbPart : {nbPart}<br/>
    	consigne : {nbPart*10 + etape}<br/>
    	
    </div>
  );
}